import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import moment from 'moment';
import userStoreModule from '@/store/modules/user';
import {uploadDocument, releaseEngineer} from '@/api/miscellaneous';
import {Toast} from 'vant';
import {useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReleaseEngineering',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const submitData = ref({
    companyDisplay: true,
    title: '',
    company: '',
    profile: '',
    receiptAreaId: userStoreModule.userDetail.areaId,
    receiptAddress: userStoreModule.userDetail.shortAddress,
    receiptLocation: '',
    expires: moment().format('YYYY-MM-DD HH:mm:ss'),
    invoiceType: '1',
    documentUrl: '',
    requirePrice: true,
    requirePhotos: false,
    requireAddress: false,
    payTerm: '1',
});
const isShowTimePicker = ref(false);
const isShowCityPicker = ref(false);
const documentName = ref('');
const uploadImage = ref('');

const onConfirm = (data: any) => {
    isShowTimePicker.value = false;
    submitData.value.expires = moment(data).format('YYYY-MM-DD HH:mm:ss');
};

const cityConfirm = (data: any) => {
    submitData.value.receiptAreaId = data[2].value;
    submitData.value.receiptAddress = Array.from(new Set(data.map((item: any) => item.label))).join('');
};

const imageAfterRead = (file: any) => {
    uploadImage.value = file.content;
};

const documentAfterRead = (data: any) => {
    const {file} = data;
    const uploading = Toast.loading({
        message: '文档上传中...',
        duration: 0,
        overlay: true,
    });
    uploadDocument({file}).then((res: any) => {
        submitData.value.documentUrl = res.url;
        documentName.value = file.name;
        uploading.clear();
    });
};

const submit = () => {
    releaseEngineer(submitData.value).then((res: any) => {
        router.push({name: 'EngineeringDetail', query: {id: res}});
    });
};

const __returned__ = { router, submitData, isShowTimePicker, isShowCityPicker, documentName, uploadImage, onConfirm, cityConfirm, imageAfterRead, documentAfterRead, submit, ref, moment, userStoreModule, uploadDocument, releaseEngineer, Toast, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})